import { Shark, Utils } from "shark-mvc";

import  { Driver } from "Models/Driver";
import { driverManager } from "Managers/driverManager";

import templateContent from "Templates/views/vehicle-return.html";
import { homeView } from "./homeView";
import { mainNavComponent } from "../../components/mainNav/mainNavComponent";
import { chargedVehicleComponent } from "../../components/chargedVehicle/chargedVehicleComponent";
import { vehicleActivityManager } from "../managers/vehicleActivityManager";

var vehicleReturnView = Shark.createJaw("vehicleReturnView");

vehicleReturnView.templateContent = templateContent;
vehicleReturnView.route = "vehicle-return";

vehicleReturnView.addMethod("beforeLoad", function () {
	Shark.set({
		currVehicleActivity: Shark.getInstance("VehicleActivity", {
			type: "return"
		})
	});

	navigator.geolocation.getCurrentPosition((data) => {
		const coords = {
			accuracy: data.coords.accuracy,
			altitude: data.coords.altitude,
			altitudeAccuracy: data.coords.altitudeAccuracy,
			heading: data.coords.heading,
			latitude: data.coords.latitude,
			longitude: data.coords.longitude,
			speed: data.coords.speed,
		}
		// console.log("success", {data}, arguments);
		// accuracy: 1228
		// altitude: null
		// altitudeAccuracy: null
		// heading: null
		// latitude: 45.6548352
		// longitude: 9.6813056
		// speed: null
		console.warn(data.coords)
		Shark.set("currGeoLocation", coords);
		Shark.get("currVehicleActivity").set("geo", coords);

		console.log(JSON.stringify(coords));
	},
	(data) => {
		console.log("", {data}, arguments);
	}); 
});

vehicleReturnView.addMethod("beforeRender", function () {
	// Ste.TODO controllare il comportamento se nom ho definito un selectedVehicleActivity
	// o se esiste ma non ha settata la proprietà necessaria
	const selectedVehicleActivity = Shark.get("selectedVehicleActivity") || [];

	Shark.get("currVehicleActivity").set("vehicleId", selectedVehicleActivity.vehicleId);
	Shark.get("currVehicleActivity").set("__vehicleName", selectedVehicleActivity.__vehicleName);

	console.log({"currVehicleActivityReturn":Shark.get("currVehicleActivity")});
});

vehicleReturnView.addMethod("backBtn_clickHandler", function () {
	Shark.openPage(homeView);
});

vehicleReturnView.addMethod("cancelBtn_clickHandler", function () {
	if (confirm("Sei sicuro di voler annullare? Se clicchi ok perderai le informazioni inserite.")) {
		localStorage.removeItem("currVehicleActivity");
		Shark.openPage(vehicleReturnView);
	}
});

vehicleReturnView.addMethod("init", function () {
    this.addComponents([mainNavComponent,chargedVehicleComponent]);
});

vehicleReturnView.addMethod("saveBtn_clickHandler", function () {
	const currVehicleActivity = Shark.get("currVehicleActivity");
	const isValid = currVehicleActivity.validate();

	if (!isValid) {
		const errorsList = currVehicleActivity.__errors.map(item => item.label).join("\n");
		alert(`Attenzione, si sono verificati i seguenti errori:\n${errorsList}`);
		return;
	}

	vehicleActivityManager.save(currVehicleActivity);
});

vehicleReturnView.addMethod("vehicleActivityManager_savedHandler", function (event) {
	alert("Operazione confermata!");
	Shark.openPage(homeView);
});

Shark.registerView(vehicleReturnView);

export { vehicleReturnView };
